import { uniqBy } from 'lodash-es';
import { request } from '@utils';

const getEmails = async ({ params, payload }) => {
  const body = {
    body: payload,
  };
  const results = await request.post(
    `/v1/emails/filter?${new URLSearchParams(params)}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getEmailById = async (emailId) => {
  const results = await request.get(`/v1/emails/${emailId}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const editEmailById = async (emailId, payload) => {
  const params = {
    body: payload,
  };
  const results = await request.patch(`/v1/emails/${emailId}`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const editEmailEntities = async (emailId, payload) => {
  const params = {
    body: payload,
  };
  const results = await request.patch(`/v1/emails/${emailId}/entities`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getEmailEntities = async (emailId) => {
  const results = await request.get(`/v1/emails/${emailId}/entities`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const deleteEmailEntities = async (emailId, payload) => {
  const params = {
    body: uniqBy(payload, 'entityId'),
  };
  const results = await request.remove(
    `/v1/emails/${emailId}/entities`,
    params
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const editEmails = async (payload) => {
  const params = {
    body: payload,
  };
  const results = await request.patch(`/v1/emails/bulk`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getEmailHistoryById = async (id) => {
  const results = await request.get(
    `/v1/changelogs?entityType=email&entityID=${id}&orderBy=createdAt&order=desc`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const syncEmails = async (id) => {
  const body = {
    body: {},
  };
  const results = await request.post(`/v1/mailboxes/${id}/sync`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getEmailBoxes = async (params, payload) => {
  const body = {
    body: payload,
  };
  const results = await request.post(
    `/v1/mailboxes/filter?${new URLSearchParams(params)}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const addEmailBox = async (payload) => {
  const body = {
    body: payload,
  };
  const results = await request.post(`/v1/mailboxes`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getOAuthMailboxURL = async (payload) => {
  const body = {
    body: payload,
  };
  const results = await request.post(`/v1/mailboxes/generateOAuthURL`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const validateEmailBox = async (id, payload) => {
  const params = {
    body: payload,
  };
  const results = await request.patch(
    `/v1/mailboxes/${id}/validate
`,
    params
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const replyEmail = async (payload) => {
  const body = {
    body: payload,
  };
  const results = await request.post(`/v1/emails/reply`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const replyEmailV2 = async (payload) => {
  const body = {
    header: {
      Accept: 'application/json',
    },
    body: payload,
  };

  const results = await request.post(`/v2/emails/reply`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const composeEmailV2 = async (payload) => {
  const body = {
    header: {
      Accept: 'application/json',
    },
    body: payload,
  };

  const results = await request.post(`/v2/emails/compose`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getSMSTemplates = async () => {
  const results = await request.get(`/v1/communications/templates/sms`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getTotals = async (id, grouping = false) => {
  const results = await request.get(
    `/v1/mailboxes/${id}/totals?grouping=${grouping}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

export {
  getEmails,
  getEmailById,
  editEmailById,
  getEmailHistoryById,
  editEmails,
  syncEmails,
  getEmailBoxes,
  addEmailBox,
  getOAuthMailboxURL,
  validateEmailBox,
  replyEmail,
  replyEmailV2,
  composeEmailV2,
  getSMSTemplates,
  getTotals,
  editEmailEntities,
  deleteEmailEntities,
  getEmailEntities,
};
